import { TableTemplate } from 'types/tableTemplate';

export const plansTableTemplate: TableTemplate[] = [
  { id: 'id', description: 'ID', originalId: 'id', width: 100 },
  { id: 'name', description: 'NOME', originalId: 'name', width: 300 },
  { id: 'description', description: 'DESCRIÇÃO', originalId: 'description', width: 300 },
  { id: 'formattedPrice', description: 'PREÇO', originalId: 'price', width: 400 },
  { id: 'formattedIsVisible', description: 'VISÍVEL', originalId: 'formattedIsVisible', width: 100 },
];
